import React, { useEffect, useRef } from 'react';
import { TweenMax, Power3 } from 'gsap';
import { Link } from 'react-router-dom';
import '../styles/Navbar.scss';

const Navbar = () => {
    let navRef = useRef(null);

    useEffect(() => {
        TweenMax.to(navRef, 1, {
            opacity: 1,
            y: 0,
            ease: Power3.easeOut,
            delay: 0.2
        });
    }, []);

    return (
        <nav ref={el => (navRef = el)} className="navbar">
            <div className="container nav-container">
                <div className="logo"><Link to="/">ODYSSEY</Link></div>
                <ul className="nav-links">
                    <li><Link to="/about">About Us</Link></li>
                    <li><Link to="/fleet">Fleet</Link></li>
                    <li><Link to="/#booking" className="btn-book">Book Now</Link></li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;
